import { render } from "./TemplateMfittBookingProcessing.vue?vue&type=template&id=89082096&scoped=true"
import script from "./TemplateMfittBookingProcessing.vue?vue&type=script&lang=js"
export * from "./TemplateMfittBookingProcessing.vue?vue&type=script&lang=js"

import "./TemplateMfittBookingProcessing.vue?vue&type=style&index=0&id=89082096&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-89082096"

export default script